module.exports = __webpack_public_path__ + "media/components/page-header/static/tide-forecast__logo--white-035593520a221e76f69614e8f95a89d7.png";